import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {

    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {

        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
